import { nowIso } from '../domain/time.js';
export class ConflictRepository {
    driver;
    constructor(driver) {
        this.driver = driver;
    }
    async raise(input) {
        // No RETURNING: minSdk 26 SQLite predates it (ADR-002); insert then read.
        const results = await this.driver.batch([
            {
                sql: `INSERT INTO sync_conflicts (op_id, aggregate_id, kind, server_detail_json, local_payload_json, raised_at)
              VALUES (?, ?, ?, ?, ?, ?)`,
                params: [
                    input.opId ?? null,
                    input.aggregateId ?? null,
                    input.kind,
                    input.serverDetailJson ?? null,
                    input.localPayloadJson ?? null,
                    nowIso(),
                ],
            },
            { sql: 'SELECT * FROM sync_conflicts WHERE id = last_insert_rowid()' },
        ]);
        return mapRow(results[1]?.rows[0] ?? {});
    }
    async listOpen() {
        const rows = await this.driver.query({
            sql: 'SELECT * FROM sync_conflicts WHERE resolved_at IS NULL ORDER BY raised_at',
        });
        return rows.map(mapRow);
    }
    async resolve(id, resolution) {
        await this.driver.execute({
            sql: 'UPDATE sync_conflicts SET resolved_at = ?, resolution = ? WHERE id = ? AND resolved_at IS NULL',
            params: [nowIso(), resolution, id],
        });
    }
}
function mapRow(row) {
    return {
        id: Number(row.id),
        opId: row.op_id == null ? null : String(row.op_id),
        aggregateId: row.aggregate_id == null ? null : String(row.aggregate_id),
        kind: String(row.kind),
        serverDetailJson: row.server_detail_json == null ? null : String(row.server_detail_json),
        localPayloadJson: row.local_payload_json == null ? null : String(row.local_payload_json),
        raisedAt: String(row.raised_at),
        resolvedAt: row.resolved_at == null ? null : String(row.resolved_at),
        resolution: row.resolution == null ? null : String(row.resolution),
    };
}
//# sourceMappingURL=conflicts.js.map